module.exports = __webpack_public_path__ + "img/mobile-sidebar.f57eefed.svg";